
const textStyle = {
  paddingTop: '25px',
};

const rowStyle = {
  cursor: 'pointer',
};

const imageRow = {
  width: '50px',
};

const imageStyle = {
  height: '50px',
  borderRadius: '3px',
};


export default {
  textStyle,
  rowStyle,
  imageRow,
  imageStyle,
};



// WEBPACK FOOTER //
// ./src/scenes/Users/components/UserList/components/UserRow/style.js